import React from 'react';
import './Partners.css';
import hopp from "../../img/Partners/hopp.png";
import ease from "../../img/Partners/ease.png";
import aigents from "../../img/Partners/aigents.png";
import apiumhub from "../../img/Partners/apiumhub.png";
import apix from "../../img/Partners/apix.png";
import dna from "../../img/Partners/dna.png";
import googdev from "../../img/Partners/googdev.png";
import guid from "../../img/Partners/guid.png";
import itea from "../../img/Partners/itea.png";
import packt from "../../img/Partners/packt.png";
import qubit from "../../img/Partners/qubit.png";
import sd from "../../img/Partners/sd.png";
import vihat from "../../img/Partners/vihat.png";
import kubecareers from "../../img/Partners/kubecareers.png";
import kubevents from "../../img/Partners/kubevents.png";

const Partners = (props) => {
    const state = {
        Partners_item: [
            {
                img: hopp,
                link: 'http://www.hopp.team/',
            },
            {
                img: ease,
                link: 'https://it-ease.com/en/',
            },
            {
                img: aigents,
                link: 'https://aigents.co/',
            },
            {
                img: apiumhub,
                link: 'https://apiumhub.com/',
            },
            {
                img: apix,
                link: 'https://apix-drive.com/',
            },
            {
                img: sd,
                link: 'https://swissdevjobs.ch/jobs/Mobile/all',
            },
            {
                img: googdev,
                link: 'https://t.me/dsc_kpi',
            },
            {
                img: guid,
                link: 'https://guid.com.ua/en/',
            },
            {
                img: itea,
                link: 'https://itea.ua/?utm_source=sitepartners&utm_medium=geekle&utm_campaign=infopart',
            },
            {
                img: packt,
                link: 'https://www.packtpub.com/',
            },
            {
                img: qubit,
                link: 'https://qubit-labs.com/',
            },
            {
                img: dna,
                link: 'https://dna325.com/',
            },
            {
                img: vihat,
                link: 'https://vihattechnologies.com/',
            },
            {
                img: kubecareers,
                link: 'https://kube.careers/',
            },
            {
                img: kubevents,
                link: 'https://kube.events/',
            },
        ],
    };

    const renderPartners_item = (item, i) => {
        return (
            <a href={item.link} target='_blank' rel="noreferrer" className="logo_item partners_img_block" key={`Numbers_item-${i}`}>
                <img className="partners_img" src={item.img} alt="Partners logo" />
            </a>
        );
    };

    return (
        <div className="partners_wrap" id='partners'>
            <div className="container">
                <h2>Partners</h2>
                <div className="partners">
                    {state.Partners_item.map((item, i) => renderPartners_item(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Partners;